export const SET_SELECTED_PRICE_ID = 'SET_SELECTED_PRICE_ID';
export const SET_PAYMENT_METHODS = 'SET_PAYMENT_METHODS';
export const SET_TRANSACTION_TYPE = 'SET_TRANSACTION_TYPE';
export const SET_USER_PROMOTIONS = 'SET_USER_PROMOTIONS';
export const SET_INVOICE = 'SET_INVOICE';
export const SET_PROMOTION = 'SET_PROMOTION';
export const CLEAR_PROMOTION = 'CLEAR_PROMOTION';
